module.exports = __webpack_public_path__ + "img/emergency_kit_03.0c689fc9.jpg";